import React from 'react';
import { __ } from '../../../../utils/translation-service';
import { PhoneIcon } from '../../header/header-mobile-old/Icons/PhoneIcon';
import { StyledStickyFooter } from './footer-sticky.style';
import { eventTracker } from '../../../../utils/EventTracker';

export const FooterSticky = (props: { phoneNumber?: string }) => (
    <StyledStickyFooter className="stickyFooter">
        <a
            href={`tel:${props.phoneNumber ? props.phoneNumber : '<r hidden>phonelead</r>'}`}
            title={__('callYourCruiseConsultant')}
            onClick={() =>
                eventTracker.track({
                    event: 'click',
                    category: 'mobile-clicktocall',
                    action: 'click',
                    label: window.location.href,
                })
            }
        >
            <PhoneIcon width={26} height={26} {...({} as any)} />
            <div>{__('callUs')}</div>
        </a>
    </StyledStickyFooter>
);
